module.exports = __webpack_public_path__ + "media/images/badge/abbonato_secondary-fda1f1bd50aba00437fcee379850ced0.png";